// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3894":"vendor-gridstack","4603":"vendor-monaco-editor","6005":"vendor-chart.js","6695":"vendor-xlsx","7389":"vendor-quill","9725":"vendor-highlight.js"}[chunkId] || chunkId) + ".millennium.js";
};